import { Entity } from '@backstage/catalog-model';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { BA_ANNOTATION } from '../pandaUsage/annotations';

// "Manage" entity tab: the squad-facing view of its own PANDA instance. Gated
// on the same annotation as Panda usage; the backend decides what the caller
// may actually see.
const pandaManageContent = EntityContentBlueprint.make({
  name: 'panda-manage',
  params: {
    path: '/manage',
    title: 'Manage',
    filter: (entity: Entity) =>
      Boolean(entity.metadata.annotations?.[BA_ANNOTATION]),
    loader: async () => {
      const { ManageContent } = await import('./ManageContent');
      return <ManageContent />;
    },
  },
});

export const pandaManageModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [pandaManageContent],
});
